import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformListSyncsMockHandler = () => {
  return http.get('*/teams/:team/syncs', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = [
      {
        cpu: '100m',
        created_at: '2024-06-17T14:09:04.540426Z',
        created_by: 'kemal@cloudquery.io',
        destinations: ['gcs-2024-06-17'],
        disabled: false,
        display_name: '',
        incremental: {
          destination: '',
          table: '',
        },
        memory: '512Mi',
        name: 'gcp-gcs-2024-06-17',
        schedule: '23 14 * * SUN#2',
        source: 'gcp-2024-06-17',
        updated_at: '2024-06-17T14:09:04.540426Z',
      },
    ];

    return HttpResponse.json(
      {
        items,
        metadata: {
          last_page: 1,
          page_size: 10,
          time_ms: 100,
          total_count: items.length,
        },
      },
      {
        status: 200,
      },
    );
  });
};
